var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTimer = function SvgIconTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75.125a1 1 0 0 0 0 2h4.5a1 1 0 1 0 0-2zM15.885 9.24a1 1 0 0 1 0 1.414l-3.178 3.178a1 1 0 0 1-1.414-1.414L14.47 9.24a1 1 0 0 1 1.414 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.75 13.125a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0M12 5.875a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5",
    clipRule: "evenodd"
  }))));
};
export default SvgIconTimer;